module.exports = __webpack_public_path__ + "static/dd-madde5-c4965f7bbe03f1f4f15f0d3df7053440.png";